export default __webpack_public_path__ + "static/media/sa-icon.d5cd559e.webp";